export default {
      id: "sli-car-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.cf73de4e.svg#sli-car",
      toString: function () {
        return this.url;
      }
    }